<template>
    <section class="m-buy-house">
        <section class="m-banner">
            <img src="../../assets/images/house/banner_2.jpg" alt="">
        </section>
        <section class="m-floor-1 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    品牌短视频
                </span>
                <router-link to="/gxnews/more/51367">
                    <img src="../../assets/images/house/more_2.png" alt="">    
                </router-link>
            </div>
            <div class="video">
                <div v-for="(item,index) in videos" :key="index">
                    <a :href="item.url">
                        <img :src="item.img" width="100%" alt="">
                    </a>
                </div>
            </div>
        </section>
        <section class="m-floor-2 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    品牌幻灯片
                </span>
                <router-link to="/houselist2">
                    <img src="../../assets/images/house/more_2.png" alt="">    
                </router-link>
            </div>
            <div class="slider">
                <swiper :options="swiperOption">
                    <swiper-slide v-for="(item,index) in pinpai" :key="index">
                        <div class="list">
                            <a :href="item.url">
                                <img :src="item.img" alt="">
                                <span>{{item.title}}</span>          
                            </a>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </section>
        <section class="m-floor-3 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    品牌大图
                </span>
                <router-link to="/houselist2">
                    <img src="../../assets/images/house/more_2.png" alt="">    
                </router-link>
            </div>
            <ul>
                <li v-for="(item,index) in data" :key="index">
                    <a :hreflang="item.url">
                        <div class="pic">
                            <img :src="item.img" width="100%" alt="">
                        </div>
                        <div class="name">{{item.title}}</div>    
                    </a>
                </li>
                
            </ul>
        </section>
    </section>
</template>

<script>
    import jsonp from 'jsonp'
    import {swiper , swiperSlide} from 'vue-awesome-swiper'

    export default {
        data(){
            return{
                swiperOption:{                   
                    watchSlidesProgress: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    loop: true,
                    loopedSlides: 5,
                    autoplay: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    on: {
                        progress: function(progress) {
                            for (var i = 0; i < this.slides.length; i++) {
                                var slide = this.slides.eq(i);
                                var slideProgress = this.slides[i].progress;
                                var modify = 1;
                                if (Math.abs(slideProgress) > 1) {
                                    modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                                }
                                var translate = slideProgress * modify * 260 + 'px';
                                var scale = 1 - Math.abs(slideProgress) / 5;
                                var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                                slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                                slide.css('zIndex', zIndex);
                                slide.css('opacity', 1);
                                if (Math.abs(slideProgress) > 3) {
                                    slide.css('opacity', 0);
                                }
                            }
                        },
                        setTransition: function(transition) {
                            for (var i = 0; i < this.slides.length; i++) {
                                var slide = this.slides.eq(i)
                                slide.transition(transition);
                            }

                        }
                    }
                },
                videos:[],
                pinpai:[],
                data:[]
            }
        },
        mounted () {
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51367&start=0&limit=1', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("videos",data);
                    this.videos = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51368&start=0&limit=3', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("pinpai",data);
                    this.pinpai = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51369&start=0&limit=30', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("data",data);
                    this.data = data;
                }
            })
        },
        methods:{
            
        }    
    }
</script>

<style lang="less" scoped>
    .common-top{
        display: flex;
        align-items: center;
        margin-bottom: 0.45rem;
        span,a{
            flex: 1;
        }
        span{
            font-size: 0.45rem;
            color: #000;
            font-weight: bold;
        }
        i{
            display: inline-block;
            width: 0.1rem;
            height: 0.4rem;
            background: #ec6244;
            border-radius: 0.2rem;
            vertical-align: middle;
        }
        a{
            text-align: right;
            font-size: 0.35rem;
            color: #adadad;
        }
        img{
            width: 20%;
        }
    }
    .floor{
        padding: 0 0.35rem;
    }
    .m-ad{
        margin-top: 0.6rem;
        img{
            width: 100%;
        }
    }
    .m-banner{
        img{
            width: 100%;
        }
    }
    .m-floor-1{
        margin-top: 0.5rem;
        /*.video{
            padding-bottom: 60%;
            background: #ccc;
        }*/        
    }
    .m-floor-2{
        margin-top: 0.7rem;
        .list{
            padding: 0.6rem 0.8rem;
            box-sizing: border-box;
            img{
                width: 100%;
                height: 6rem;
            }
            a{
                display: block;
                position: relative;
                border: 2px solid #fff;
                box-shadow: 0.07rem 0.07rem 0.05rem #c7c7c7;
            }
            span{
                display: block;
                bottom: 0;
                left: 0;
                padding: 0.2rem 0;
                background: #fff;
                text-align: center;
                width: 100%;
                position: absolute;
                color: #000;
                font-size: 0.32rem;
            }
        }   
    }
    .m-floor-3{
        margin-top: 0.7rem;
        padding-bottom: 1.7rem;
        ul{
            overflow: hidden;
        }
        li{
            width: 31.5%;
            float: left;
            margin: 0 0.25rem 0.25rem 0;
            &:nth-of-type(3n){
                margin-right: 0;
            }
            img{
                width: 100%;
                height: 2rem;
            }
            .pic{
                box-shadow: 0.07rem 0.07rem 0.05rem #c7c7c7; 
            }
            .name{
                font-size: 0.32rem;
                margin-top: 0.1rem;
                text-align: center;
                color: #ed7646;
            }
        }        
    }
</style>